module.exports = __webpack_public_path__ + "img/dtr.70153428.svg";